import { AccountMode } from "services/typewriter/segment";
import { useFamilyModeSetting } from "./useFamilyModeSetting";

export function useAccountMode(): { accountMode: AccountMode } {
  const { isFamilyModeOn } = useFamilyModeSetting();
  const accountMode = isFamilyModeOn ? AccountMode.Family : AccountMode.Studio;

  return { accountMode };
}
